import { BrandFavicon } from '../BrandFavicon';
import {
  formatSourceCount,
  formatSourcePercent,
  sourceDisplayLabel,
} from '../../utils/source-insights';
import type { SourceInsightsDomainItem } from '../../types';
import { SourceDisplayTypeBadge } from './SourceDisplayTypeBadge';

export function SourceMiniList({
  items,
  emptyMessage = 'هنوز منبعی شناسایی نشده است.',
}: {
  items: SourceInsightsDomainItem[];
  emptyMessage?: string;
}) {
  if (items.length === 0) {
    return <p className="py-4 text-center fs--1 text-500 mb-0">{emptyMessage}</p>;
  }

  return (
    <ul className="list-unstyled d-flex flex-column gap-2 mb-0">
      {items.map((row) => (
        <li
          key={row.sourceDomainId}
          className="d-flex align-items-center justify-content-between gap-3 rounded-3 border bg-body-tertiary px-3 py-2"
        >
          <div className="d-flex align-items-center gap-2 min-w-0">
            <BrandFavicon
              host={row.host}
              name={sourceDisplayLabel(row.host, row.displayName)}
              size="sm"
            />
            <div className="min-w-0">
              <p className="text-truncate fs--1 fw-medium text-1000 mb-0">
                {sourceDisplayLabel(row.host, row.displayName)}
              </p>
              <div className="mt-1">
                <SourceDisplayTypeBadge type={row.displayType} />
              </div>
            </div>
          </div>
          <div className="flex-shrink-0 text-end fs--2 text-500" style={{ fontVariantNumeric: 'tabular-nums' }}>
            <p className="fw-semibold text-800 mb-0">{formatSourcePercent(row.usedPercent)}</p>
            <p className="mb-0">{formatSourceCount(row.citations)} Citation</p>
          </div>
        </li>
      ))}
    </ul>
  );
}
